/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Patient routes
 */

// Pages
import PatientManagement from '@nephro/pages/Patients/PatientManagement';
import PatientCreation from '@nephro/pages/Patients/PatientCreation';
import PatientViewEdit from '@nephro/pages/Patients/PatientViewEdit';
import PatientsMassiveProcessing from '@nephro/pages/Patients/PatientsMassiveProcessing';
import PatientsMassiveProcessingById from '@nephro/pages/Patients/PatientsMassiveProcessingById';

const pathStart = '/main/patients';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: PatientManagement,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: PatientViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: PatientViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: PatientCreation,
    exact: true
  },
  {
    path: `${pathStart}/massive-processing`,
    isProtected: true,
    component: PatientsMassiveProcessing,
    exact: true
  },
  {
    path: `${pathStart}/massive-processing/:id`,
    isProtected: true,
    component: PatientsMassiveProcessingById,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
